import "../css/Innocamaras.css"

const Innocamaras = () => {

    return (
        <main id="innocamaras">
            <img src="/images/banner-innocamaras.webp" alt="logo inocamaras" />
            <h1>PROXECTO COFINANCIADO POR IGAPE, XUNTA DE GALICIA E FONDO EUROPEO DE DESENVOLVEMENTO REXIONAL DO PROGRAMA OPERATIVO 2014-2020</h1>

            <section>
                <p>
                    <strong>Spica SL. </strong>ha sido beneficiaria del <strong>Fondo Europeo de Desarrollo Regional </strong>cuyo objetivo es potenciar la investigación, el desarrollo tecnológico y la innovación y gracias al que ha podido incorporar la innovación en su gestión implantando el Esquema Nacional de Seguridad en la empresa, lo que le permite mejorar su competitividad.
                </p>
                <p>Esta acción ha tenido lugar durante 2020. Para ello ha contado con el apoyo del programa <strong>InnoCámaras</strong> de la <strong>Cámara de Comercio de Pontevedra, Vigo y Vilagarcía.</strong></p>
                <p>Una manera de hacer Europa.</p>
            </section>
        </main>
    )
}

export default Innocamaras
